import ScrollService from './scrollService';

const ScrollServiceInstance = new ScrollService();
export default ScrollServiceInstance;
